import { IUserCredentials } from "core/interfaces/user-credentials.interface";

export type ISignInCredentials = Omit<IUserCredentials, "confirm_password">

export const defaultSignInValues: ISignInCredentials = {
    email: "",
    password: "",
}
